// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { EMRConnectionType } from "../../types";
import { getEMRHubConnections } from "../../api";

export const useEMRHubConnections = (
  clinicId: string | undefined,
  hubId: string | undefined
) => {
  const { getToken } = useTokenAccess();

  return useQuery<Array<EMRConnectionType>>({
    queryKey: ["emr-hub-connections", clinicId, hubId],
    queryFn: async () => {
      if (!clinicId || !hubId) throw new Error();
      const token = await getToken();
      return getEMRHubConnections(token, clinicId, hubId);
    },
    refetchOnWindowFocus: false,
    staleTime: 0, // do not cache so data is always fresh on the dashboard
  });
};
